{
  "v3.ta.agent.acces": "Accès de l’agent auprès du propriétaire",
  "v3.ta.agent.aucun_modele": "aucun",
  "v3.ta.agent.aucun_modele_autorise": "Aucun modèle d’IA autorisé dans ce projet.",
  "v3.ta.agent.configuration": "Configuration",
  "v3.ta.agent.consigne": "Consigne : {{consigne}}",
  "v3.ta.agent.consigne_champ": "Consigne",
  "v3.ta.agent.cree": "Agent créé.",
  "v3.ta.agent.creer": "Créer l’agent",
  "v3.ta.agent.echec_creer": "L’agent n’a pas été créé.",
  "v3.ta.agent.echec_enregistrer": "L’agent n’a pas été enregistré.",
  "v3.ta.agent.en_revue_non_modifiable": "L’agent est en revue : il n’est pas modifiable.",
  "v3.ta.agent.enregistre": "Agent enregistré.",
  "v3.ta.agent.enregistrer": "Enregistrer",
  "v3.ta.agent.etat.draft": "Brouillon",
  "v3.ta.agent.etat.in_review": "En revue",
  "v3.ta.agent.etat.promoted": "Promu à l’organisation",
  "v3.ta.agent.etat.refused": "Refusé",
  "v3.ta.agent.etat_motif": "{{etat}} — motif : {{motif}}",
  "v3.ta.agent.fiche_etat.brouillon": "Brouillon",
  "v3.ta.agent.fiche_etat.en_revue": "En revue",
  "v3.ta.agent.fiche_etat.promu": "Promu à l’organisation",
  "v3.ta.agent.fiche_etat.refuse": "Refusé",
  "v3.ta.agent.libelle": "agent",
  "v3.ta.agent.modele": "modèle {{modele}}",
  "v3.ta.agent.modele_champ": "Modèle d’IA",
  "v3.ta.agent.modele_nom": "Modèle : {{modele}}",
  "v3.ta.agent.modifier": "Modifier le brouillon",
  "v3.ta.agent.nom": "Nom",
  "v3.ta.agent.nom_requis": "Le nom est obligatoire.",
  "v3.ta.agent.outils": "Outils : {{outils}}",
  "v3.ta.agent.preparation": "préparation à l’exécution",
  "v3.ta.agent.pret": "L’agent peut s’exécuter.",
  "v3.ta.agent.role": "Rôle : {{role}}",
  "v3.ta.agent.role_champ": "Rôle",
  "v3.ta.agent.role_exemples": "Par exemple : product owner, développeur, testeur.",
  "v3.ta.agent.role_libre": "Rôle libre",
  "v3.ta.agent.role_libre_option": "Rôle libre de l’organisation",
  "v3.ta.agent.role_requis": "Le rôle est obligatoire.",
  "v3.ta.agent.titre": "Agent personnalisé du projet",
  "v3.ta.agent.titre_creer": "Créer un agent personnalisé du projet",
  "v3.ta.agent.titre_modifier": "Modifier le brouillon d’un agent",
  "v3.ta.agent.tous": "Tous les agents",
  "v3.ta.agents.agent_a_executer": "Agent à exécuter",
  "v3.ta.agents.associations": "associations du serveur",
  "v3.ta.agents.aucune_association": "Aucune association approuvée et active.",
  "v3.ta.agents.aucune_choisie": "Choisissez une finalité pour voir sa décision et votre consentement.",
  "v3.ta.agents.choisir_agent": "Choisir un agent…",
  "v3.ta.agents.consentement_echec": "Le consentement n’a pas été enregistré.",
  "v3.ta.agents.consentement_enregistre": "Consentement enregistré.",
  "v3.ta.agents.consentement_requis": "Chaque personne donne son consentement avant d’exécuter l’agent.",
  "v3.ta.agents.consenti": "Consentement donné jusqu’au {{date}}.",
  "v3.ta.agents.creer": "Créer un agent",
  "v3.ta.agents.declarer_finalite": "Déclarer une finalité",
  "v3.ta.agents.demander_promotion": "Demander la promotion",
  "v3.ta.agents.donner_consentement": "Donner mon consentement",
  "v3.ta.agents.en_cours": "L’agent travaille…",
  "v3.ta.agents.executer": "Exécuter",
  "v3.ta.agents.executer_serveur": "Exécuter par le serveur d’outils",
  "v3.ta.agents.executer_titre": "Exécuter un agent",
  "v3.ta.agents.execution_echec": "L’exécution n’a pas abouti.",
  "v3.ta.agents.executions": "Exécutions",
  "v3.ta.agents.executions_vide": "Aucune exécution.",
  "v3.ta.agents.finalites": "Finalités du projet",
  "v3.ta.agents.finalites_vide": "Aucune finalité déclarée.",
  "v3.ta.agents.instruction": "Instruction",
  "v3.ta.agents.instruction_requise": "Saisissez une instruction.",
  "v3.ta.agents.jusqu_au": "jusqu’au {{date}}",
  "v3.ta.agents.lire_associations": "Lire les associations",
  "v3.ta.agents.liste": "Agents du projet",
  "v3.ta.agents.liste_libelle": "agents du projet",
  "v3.ta.agents.motif": "motif : {{motif}}",
  "v3.ta.agents.non_consenti": "Consentement non donné.",
  "v3.ta.agents.promotion_echec": "La promotion n’a pas abouti.",
  "v3.ta.agents.promotion_faite": "Promotion mise à jour.",
  "v3.ta.agents.relance": "Agent relancé.",
  "v3.ta.agents.relance_echec": "La relance n’a pas abouti.",
  "v3.ta.agents.relancer": "Relancer",
  "v3.ta.agents.relancer_nom": "Relancer {{nom}}",
  "v3.ta.agents.relecteur": "Relecteur (identifiant)",
  "v3.ta.agents.relecteur_aide": "Une personne de l’organisation, autre que l’auteur.",
  "v3.ta.agents.relecteur_requis": "Désignez un relecteur de l’organisation.",
  "v3.ta.agents.resultat_vide": "Aucun résultat pour l’instant.",
  "v3.ta.agents.retirer_consentement": "Retirer mon consentement",
  "v3.ta.agents.retirer_promotion": "Retirer la promotion",
  "v3.ta.agents.roles_du_modele": "Rôles d’agent du modèle : {{roles}}",
  "v3.ta.agents.sans_sortie": "Exécution terminée sans texte de sortie.",
  "v3.ta.agents.serveur": "Serveur d’outils (identifiant)",
  "v3.ta.agents.serveur_lance": "Exécution lancée ({{job}}), écrite au journal.",
  "v3.ta.agents.serveur_requis": "Saisissez l’identifiant du serveur d’outils.",
  "v3.ta.agents.serveur_titre": "Exécuter par un serveur d’outils",
  "v3.ta.agents.titre": "Agents personnalisés et finalités du projet",
  "v3.ta.agents.usage": "Exécution {{id}} · {{jetons}} jetons",
  "v3.ta.agents.valable": "Valable {{jours}} jours.",
  "v3.ta.agents.vide": "Aucun agent personnalisé dans ce projet.",
  "v3.ta.annuler": "Annuler",
  "v3.ta.arrivee.v3_p07": "le paquet v3-p07 (réglages du projet)",
  "v3.ta.arrivee.v5": "la vague V5",
  "v3.ta.categories.completer": "Compléter par un changement",
  "v3.ta.categories.deroger": "Demander une dérogation",
  "v3.ta.categories.ecart": "Écart à l’imposée : {{liste}}",
  "v3.ta.categories.imposee": "Imposée : {{valeur}}",
  "v3.ta.categories.liste": "choix par catégorie",
  "v3.ta.categories.modifier": "Modifier le choix",
  "v3.ta.categories.obligatoire_vide": "Catégorie obligatoire vide.",
  "v3.ta.categories.regle_propagation": "Seules les catégories héritées suivent les propagations ; un choix propre ne change que par une demande de changement.",
  "v3.ta.categories.titre": "Technologies du projet — par catégorie",
  "v3.ta.categories.vide": "Aucune catégorie technologique.",
  "v3.ta.changement.libelle": "changement technologique",
  "v3.ta.changements.auteur": "par {{auteur}}",
  "v3.ta.changements.filtre_etat": "État",
  "v3.ta.changements.filtre_origine": "Origine",
  "v3.ta.changements.liste": "changements technologiques",
  "v3.ta.changements.nouveau": "Nouveau changement",
  "v3.ta.changements.origine.du_projet": "Du projet",
  "v3.ta.changements.origine.propagee": "Propagée par le programme ou l’organisation",
  "v3.ta.changements.origine.toutes": "Toutes les origines",
  "v3.ta.changements.reprise": "Éléments repris : {{fait}} / {{total}}",
  "v3.ta.changements.titre": "Changements technologiques du projet",
  "v3.ta.changements.toutes": "Tous les états",
  "v3.ta.changements.vide": "Aucun changement technologique.",
  "v3.ta.code.AGENT_IN_REVIEW": "L’agent est en revue : il n’est pas modifiable.",
  "v3.ta.code.AGENT_MODEL_MISSING": "Le modèle de l’agent n’est pas accordé à l’organisation.",
  "v3.ta.code.AGENT_PROMOTED_LOCKED": "L’agent est promu à l’organisation : il n’est plus modifiable ici.",
  "v3.ta.code.AGENT_PROMOTION_STATE": "La promotion n’est pas permise dans l’état actuel de l’agent.",
  "v3.ta.code.AGENT_REVIEWER_REQUIRED": "Désignez un relecteur de l’organisation.",
  "v3.ta.code.AGENT_REVIEWER_UNKNOWN": "Relecteur inconnu dans l’organisation.",
  "v3.ta.code.AI_CONSENT_MISSING": "Votre consentement manque pour la finalité de cet agent.",
  "v3.ta.code.AI_KILL_SWITCH_ACTIVE": "L’IA est arrêtée par l’organisation ou la plateforme.",
  "v3.ta.code.AI_MODEL_UNAVAILABLE": "Le modèle d’IA est indisponible.",
  "v3.ta.code.AI_PURPOSE_MISSING": "Aucune finalité approuvée pour cet agent.",
  "v3.ta.code.AI_PURPOSE_OR_CONSENT_DENIED": "Finalité ou consentement manquant pour exécuter cet agent.",
  "v3.ta.code.AI_PURPOSE_PENDING": "La finalité de cet agent attend la décision de l’organisation.",
  "v3.ta.code.AI_PURPOSE_PENDING_EXISTS": "Une finalité de ce code attend déjà une décision.",
  "v3.ta.code.COMPOSITION_HORS_MODELE": "Le modèle du projet n’admet pas cette composition.",
  "v3.ta.code.CONFLIT_DE_VERSION": "L’agent a été modifié entre-temps : rechargez la fiche.",
  "v3.ta.code.DROIT_NON_TENU": "Vous ne tenez pas le droit requis pour ce geste.",
  "v3.ta.code.IDEMPOTENCE_CONFLIT": "Une demande différente a déjà été envoyée avec cette clé : rouvrez le dialogue.",
  "v3.ta.code.QUOTA_EXCEEDED": "Limite de relances atteinte.",
  "v3.ta.code.SELF_REVIEW_REFUSED": "Le relecteur doit être une autre personne que l’auteur.",
  "v3.ta.code.TECHNOLOGIE_NON_PROPOSABLE": "Une technologie choisie n’est pas proposable : choisissez une technologie qualifiée et autorisée.",
  "v3.ta.code.TECH_CHANGE_ADR_REQUIRED": "Un changement majeur exige une décision d’architecture liée.",
  "v3.ta.code.TECH_CHANGE_ALREADY_VOTED": "Vous avez déjà décidé ce changement.",
  "v3.ta.code.TECH_CHANGE_CONFIRMATION_MISSING": "Une confirmation nominative manque avant la soumission.",
  "v3.ta.code.TECH_CHANGE_IMMUTABLE": "Ce changement n’est plus modifiable.",
  "v3.ta.code.TECH_CHANGE_IN_PROGRESS": "Un autre changement de cette catégorie est en cours.",
  "v3.ta.code.TECH_CHANGE_NOT_DECIDED": "Le changement n’est pas encore décidé.",
  "v3.ta.code.TECH_CHANGE_REWORK_OPEN": "La reprise n’est pas terminée : le changement ne peut pas être clos.",
  "v3.ta.code.TECH_CHANGE_SELF_APPROVAL": "L’auteur d’une demande ne peut pas la décider.",
  "v3.ta.code.TECH_CHANGE_TRANSITION": "Ce geste n’est pas permis dans l’état actuel du changement.",
  "v3.ta.code.TECH_ENTRY_NOT_IMPOSED": "Cette technologie n’est pas imposée : aucune dérogation n’est nécessaire.",
  "v3.ta.code.TECH_NOT_GENERABLE_UNCONFIRMED": "Combinaison non générable : assumez la livraison manuelle avant de soumettre.",
  "v3.ta.code.VALIDATION_ERROR": "La saisie est refusée par la passerelle : vérifiez les champs.",
  "v3.ta.code.WAIVER_ALREADY_ACTIVE": "Une dérogation est déjà active pour cette technologie.",
  "v3.ta.code.WAIVER_EXPIRY_REQUIRED": "L’échéance de la dérogation est obligatoire.",
  "v3.ta.decider.accepter": "Accepter",
  "v3.ta.decider.auteur": "Vous êtes l’auteur de cette demande : une autre personne décide.",
  "v3.ta.decider.decide": "Décision enregistrée, écrite au journal.",
  "v3.ta.decider.decision": "Décision",
  "v3.ta.decider.echec": "La décision n’a pas été enregistrée.",
  "v3.ta.decider.motif_court": "Le motif compte au moins {{min}} caractères.",
  "v3.ta.decider.refuser": "Refuser",
  "v3.ta.decider.titre": "Décider un changement technologique",
  "v3.ta.derogation.aucune_imposee": "Aucune technologie imposée au projet : aucune dérogation à demander.",
  "v3.ta.derogation.categorie_technologie": "Catégorie et technologie",
  "v3.ta.derogation.conservee": "Technologie actuelle conservée : {{valeur}}",
  "v3.ta.derogation.demandee": "Dérogation demandée, écrite au journal.",
  "v3.ta.derogation.demander": "Demander la dérogation",
  "v3.ta.derogation.echeance": "Échéance",
  "v3.ta.derogation.echeance_future": "L’échéance est obligatoire et doit être dans le futur.",
  "v3.ta.derogation.echec": "La dérogation n’a pas été demandée.",
  "v3.ta.derogation.justification": "Justification",
  "v3.ta.derogation.justification_requise": "La justification est obligatoire.",
  "v3.ta.derogation.sans_entree": "Aucune technologie actuelle à conserver : la dérogation ne s’applique pas.",
  "v3.ta.derogation.suite_attente": "La propagation attend la décision pour ce projet.",
  "v3.ta.derogation.suite_organisation": "La dérogation est décidée par l’organisation.",
  "v3.ta.derogation.suite_propagation": "Avant une propagation, la propagation attend la décision pour ce projet.",
  "v3.ta.derogation.suite_refusee": "Refusée ou échue, le changement s’applique.",
  "v3.ta.derogation.titre_ecart": "Demander une dérogation pour garder l’écart",
  "v3.ta.derogation.titre_technologique": "Demander une dérogation technologique",
  "v3.ta.derogation.vise": "{{ref}} — {{categorie}}",
  "v3.ta.dimension.code": "Code",
  "v3.ta.dimension.design": "Conception",
  "v3.ta.dimension.environments": "Environnements",
  "v3.ta.dimension.versions": "Versions",
  "v3.ta.ecran_non_realise": "« {{ecran}} » n’est pas encore réalisé : il arrive avec {{arrivee}}.",
  "v3.ta.etat.chargement": "Chargement : {{quoi}}…",
  "v3.ta.etat.en_cours": "En cours…",
  "v3.ta.etat.erreur": "Lecture impossible : {{quoi}}.",
  "v3.ta.etat.introuvable": "Introuvable : {{quoi}}.",
  "v3.ta.etat.reessayer": "Réessayer",
  "v3.ta.etat.refus": "Accès refusé : {{quoi}}.",
  "v3.ta.execution.error": "En erreur",
  "v3.ta.execution.idle": "Au repos",
  "v3.ta.execution.running": "En cours",
  "v3.ta.fiche.adr": "Décision d’architecture liée (numéro)",
  "v3.ta.fiche.adr_requise": "Un changement majeur exige une décision d’architecture liée.",
  "v3.ta.fiche.ajouter_reprise": "Ajouter un élément à reprendre",
  "v3.ta.fiche.analyser": "Analyser",
  "v3.ta.fiche.annuler_changement": "Annuler le changement",
  "v3.ta.fiche.annuler_titre": "Annuler le changement {{ref}} ?",
  "v3.ta.fiche.clore": "Clore",
  "v3.ta.fiche.comptes": "Éléments à reprendre : {{elements}} · tests : {{tests}} · exigences : {{exigences}}",
  "v3.ta.fiche.confirmations": "Confirmations nominatives",
  "v3.ta.fiche.confirmee": "{{dimension}} confirmée par {{par}} le {{le}}",
  "v3.ta.fiche.confirmer_a_mon_nom": "Confirmer à mon nom",
  "v3.ta.fiche.decider": "Décider",
  "v3.ta.fiche.declaration": "Déclaration",
  "v3.ta.fiche.declaration_requise": "Saisissez votre déclaration.",
  "v3.ta.fiche.derogation_ecart": "Demander la dérogation pour garder l’écart",
  "v3.ta.fiche.dimension": "Dimension à confirmer",
  "v3.ta.fiche.echec": "Le geste n’a pas abouti.",
  "v3.ta.fiche.enregistrer": "Enregistrer le brouillon",
  "v3.ta.fiche.fait": "Fait.",
  "v3.ta.fiche.garder_ecart": "Garder l’écart",
  "v3.ta.fiche.garder_ecart_titre": "Garder l’écart à {{ref}} ?",
  "v3.ta.fiche.impact": "Analyse d’impact",
  "v3.ta.fiche.livraison_manuelle": "J’assume une livraison manuelle (combinaison non générable).",
  "v3.ta.fiche.motif": "Motif",
  "v3.ta.fiche.motif_aide": "Modifier le motif ou la valeur annule l’analyse.",
  "v3.ta.fiche.motif_decision": "Motif de la décision : {{motif}}",
  "v3.ta.fiche.non_analysee": "Analyse d’impact non faite.",
  "v3.ta.fiche.non_regression": "Déclaration de non-régression",
  "v3.ta.fiche.non_regression_requise": "La déclaration de non-régression est obligatoire pour clore.",
  "v3.ta.fiche.reprise": "Éléments à reprendre",
  "v3.ta.fiche.reprise_vide": "Aucun élément à reprendre.",
  "v3.ta.fiche.risque": "Risque de régression : {{risque}}",
  "v3.ta.fiche.soumettre": "Soumettre",
  "v3.ta.fiche.titre": "Changement technologique",
  "v3.ta.fiche.tous": "Tous les changements",
  "v3.ta.fiche.trace": "Le geste et son motif sont écrits au journal.",
  "v3.ta.fiche.verifier_reprise": "Vérifier la reprise",
  "v3.ta.finalite.approved": "Approuvée",
  "v3.ta.finalite.proposed": "Déclarée",
  "v3.ta.finalite.refused": "Refusée",
  "v3.ta.finalite.superseded": "Remplacée",
  "v3.ta.finalite.withdrawn": "Retirée",
  "v3.ta.finalite_dialogue.agent": "Agent",
  "v3.ta.finalite_dialogue.code": "Code de la finalité",
  "v3.ta.finalite_dialogue.code_requis": "Le code de la finalité est obligatoire.",
  "v3.ta.finalite_dialogue.declaree": "Finalité déclarée, écrite au journal.",
  "v3.ta.finalite_dialogue.declarer": "Déclarer",
  "v3.ta.finalite_dialogue.duree": "Durée de validité (jours)",
  "v3.ta.finalite_dialogue.duree_max": "{{max}} jours au plus.",
  "v3.ta.finalite_dialogue.echec": "La finalité n’a pas été déclarée.",
  "v3.ta.finalite_dialogue.suite_consentement": "Une fois approuvée, chaque personne donne son consentement.",
  "v3.ta.finalite_dialogue.suite_organisation": "La finalité est décidée par l’organisation.",
  "v3.ta.finalite_dialogue.titre": "Déclarer la finalité de traitement IA d’un agent",
  "v3.ta.historique.aucun_ecart": "Aucun écart entre les deux versions.",
  "v3.ta.historique.aucune": "Aucune version choisie.",
  "v3.ta.historique.auteur": "Auteur : {{auteur}}",
  "v3.ta.historique.comparer": "Comparer",
  "v3.ta.historique.comparer_avec": "Comparer avec",
  "v3.ta.historique.ecarts": "écarts entre versions",
  "v3.ta.historique.introuvable": "Version {{n}} introuvable : la version courante est affichée.",
  "v3.ta.historique.ligne": "Version {{n}} — {{origine}}",
  "v3.ta.historique.liste": "versions des technologies",
  "v3.ta.historique.nombre_choix": "{{n}} choix technologiques.",
  "v3.ta.historique.titre": "Technologies du projet — historique",
  "v3.ta.historique.version_affichee": "Version affichée",
  "v3.ta.historique.version_n": "Version {{n}}",
  "v3.ta.historique.vide": "Aucune version : le lancement n’est pas terminé.",
  "v3.ta.lancement.ajouter_composant": "Ajouter un composant",
  "v3.ta.lancement.categories_vides": "Choisissez une technologie pour : {{liste}}.",
  "v3.ta.lancement.choisir": "Choisir…",
  "v3.ta.lancement.choix_propre": "Choix propre",
  "v3.ta.lancement.composition_vide": "Ajoutez au moins un composant.",
  "v3.ta.lancement.deja_termine": "Le lancement est déjà terminé.",
  "v3.ta.lancement.echec_enregistrer": "Le brouillon n’a pas été enregistré.",
  "v3.ta.lancement.echec_terminer": "Le lancement n’a pas été terminé.",
  "v3.ta.lancement.enregistre": "Brouillon enregistré.",
  "v3.ta.lancement.enregistrer": "Enregistrer le brouillon",
  "v3.ta.lancement.etape.1": "composition technique",
  "v3.ta.lancement.etape.2": "technologies par catégorie",
  "v3.ta.lancement.etape.3": "récapitulatif",
  "v3.ta.lancement.etape_k": "Étape {{k}} sur 3 : {{titre}}",
  "v3.ta.lancement.heritage": "Héritage — {{categorie}}",
  "v3.ta.lancement.herite": "Hériter",
  "v3.ta.lancement.herite_vide": "Rien à hériter.",
  "v3.ta.lancement.modifier_composant": "Modifier",
  "v3.ta.lancement.modifier_composant_nom": "Modifier {{element}}",
  "v3.ta.lancement.obligatoire": "(obligatoire)",
  "v3.ta.lancement.pile_composant": "Pile du composant",
  "v3.ta.lancement.pile_ou_composition": "Pile prête ou composition",
  "v3.ta.lancement.pile_prete": "Pile prête qualifiée",
  "v3.ta.lancement.pile_requise": "Saisissez la pile du composant.",
  "v3.ta.lancement.plateforme": "Plateforme cible",
  "v3.ta.lancement.plateforme_aucune": "Aucun système qualifié",
  "v3.ta.lancement.plus_tard": "Plus tard",
  "v3.ta.lancement.precedente": "Étape précédente",
  "v3.ta.lancement.retirer_composant": "Retirer",
  "v3.ta.lancement.retirer_composant_nom": "Retirer {{element}}",
  "v3.ta.lancement.retirer_confirmer": "Retirer le composant {{element}} ?",
  "v3.ta.lancement.retirer_consequence": "Ses liaisons sont retirées avec lui.",
  "v3.ta.lancement.role_composant": "Rôle du composant",
  "v3.ta.lancement.suivante": "Étape suivante",
  "v3.ta.lancement.sur_mesure": "Composition sur mesure",
  "v3.ta.lancement.technologie": "Technologie — {{categorie}}",
  "v3.ta.lancement.termine": "Lancement terminé.",
  "v3.ta.lancement.terminer": "Terminer le lancement",
  "v3.ta.lancement.titre": "Lancement du projet",
  "v3.ta.lancement.v1_annoncee": "La version 1 des technologies sera créée à la fin du lancement.",
  "v3.ta.lancement.voir_technologies": "Voir les technologies",
  "v3.ta.nouveau.ajouter_composant": "Ajouter le composant",
  "v3.ta.nouveau.ajouter_liaison": "Ajouter la liaison",
  "v3.ta.nouveau.apres": "Composition cible",
  "v3.ta.nouveau.aucune_valeur": "Aucune technologie qualifiée et autorisée",
  "v3.ta.nouveau.avant": "Composition actuelle",
  "v3.ta.nouveau.categorie": "Catégorie",
  "v3.ta.nouveau.cree": "Brouillon créé.",
  "v3.ta.nouveau.creer": "Créer le brouillon",
  "v3.ta.nouveau.de": "De",
  "v3.ta.nouveau.echec": "Le brouillon n’a pas été créé.",
  "v3.ta.nouveau.motif_requis": "Le motif est obligatoire.",
  "v3.ta.nouveau.nature": "Nature du changement",
  "v3.ta.nouveau.nature_composition": "Composition de l’application",
  "v3.ta.nouveau.nature_valeur": "Valeur d’une catégorie",
  "v3.ta.nouveau.retirer_liaison": "Retirer",
  "v3.ta.nouveau.retirer_liaison_nom": "Retirer la liaison {{de}} → {{vers}}",
  "v3.ta.nouveau.titre": "Nouveau changement technologique",
  "v3.ta.nouveau.valeur": "Valeur cible",
  "v3.ta.nouveau.valeur_aide": "Seules les technologies qualifiées et autorisées sont proposées ; sinon, demandez une dérogation.",
  "v3.ta.nouveau.vers": "Vers",
  "v3.ta.preparation.AI_CONSENT_MISSING": "Votre consentement manque pour la finalité de cet agent.",
  "v3.ta.preparation.AI_PURPOSE_MISSING": "Aucune finalité approuvée pour cet agent.",
  "v3.ta.preparation.AI_PURPOSE_PENDING": "La finalité de cet agent attend la décision de l’organisation.",
  "v3.ta.preparation.ok": "L’agent peut s’exécuter.",
  "v3.ta.reprise.done": "faite",
  "v3.ta.reprise.todo": "à faire",
  "v3.ta.reprise.verified": "vérifiée",
  "v3.ta.risque.high": "élevé",
  "v3.ta.risque.low": "faible",
  "v3.ta.risque.medium": "moyen",
  "v3.ta.role.donnees": "Données",
  "v3.ta.role.interface": "Interface",
  "v3.ta.role.service": "Service",
  "v3.ta.role.service_de_plateforme": "Service de plateforme",
  "v3.ta.sans_projet": "Choisissez un projet pour ouvrir cet écran.",
  "v3.ta.statut.analysis": "Analysée",
  "v3.ta.statut.cancelled": "Annulée",
  "v3.ta.statut.closed": "Close",
  "v3.ta.statut.deviation_kept": "Écart gardé",
  "v3.ta.statut.draft": "Brouillon",
  "v3.ta.statut.excluded": "Exclue",
  "v3.ta.statut.in_review": "Soumise",
  "v3.ta.statut.pending": "En attente",
  "v3.ta.statut.propagated": "Propagée",
  "v3.ta.statut.propagating": "En propagation",
  "v3.ta.statut.refused": "Refusée",
  "v3.ta.statut.rework": "En reprise",
  "v3.ta.statut.to_examine": "À confirmer (propagée)",
  "v3.ta.statut.to_reconcile": "À réconcilier",
  "v3.ta.statut.to_validate": "À valider",
  "v3.ta.statut.verified": "Vérifiée",
  "v3.ta.technologies.ajouter_composant": "Ajouter un composant",
  "v3.ta.technologies.comparer_programme": "Comparer au programme",
  "v3.ta.technologies.composant": "{{role}} : {{element}}",
  "v3.ta.technologies.composants": "Composants retenus",
  "v3.ta.technologies.composants_vide": "Aucune technologie retenue : terminez le lancement.",
  "v3.ta.technologies.demander_changement": "Demander un changement",
  "v3.ta.technologies.lancement": "lancement du projet",
  "v3.ta.technologies.lancement_a_terminer": "Le lancement du projet n’est pas terminé.",
  "v3.ta.technologies.lancement_termine": "Lancement terminé : technologies en version {{version}}.",
  "v3.ta.technologies.onglet.categories": "Par catégorie",
  "v3.ta.technologies.onglet.composition": "Composition",
  "v3.ta.technologies.onglet.historique": "Historique",
  "v3.ta.technologies.onglets": "Vues des technologies",
  "v3.ta.technologies.origine.change_request": "demande {{ref}}",
  "v3.ta.technologies.origine.launch": "lancement",
  "v3.ta.technologies.origine.propagation": "propagation {{ref}}",
  "v3.ta.technologies.origine.reprise_adr0109": "reprise de l’existant",
  "v3.ta.technologies.pile": "Pile prête : {{pile}}",
  "v3.ta.technologies.source.organisation": "Héritée de l’organisation",
  "v3.ta.technologies.source.programme": "Héritée du programme",
  "v3.ta.technologies.source.projet": "Choix propre au projet",
  "v3.ta.technologies.source.reprise": "Reprise de l’existant",
  "v3.ta.technologies.terminer_lancement": "Terminer le lancement",
  "v3.ta.technologies.titre": "Technologies du projet"
}
